import React, { useMemo } from 'react';
import { GridWrapper } from './Attendance.styled';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';

const GradeDataTable = (props) => {
  const apiRef = useGridApiRef();
  const {
    gradeTableData: tableData,
    isAttendanceAudit,
    handleCellClick,
    handleKeyDown,
    searchText,
  } = props;

  const pinnedColumns = {
    left: isAttendanceAudit
      ? ['name']
      : ['watch', 'lastName', 'firstName', 'tags'],
  };

  const filteredRows = useMemo(() => {
    if (!searchText) return tableData?.rows;
    const lowerSearch = searchText.toLowerCase();
    return tableData?.rows?.filter((row) =>
      Object.values(row).some(
        (value) => value && value?.toString().toLowerCase().includes(lowerSearch)
      )
    );
  }, [searchText, tableData.rows]);

  return (
      <GridWrapper onKeyDown={handleKeyDown} tabIndex={0}>
        <DataGridPro
          //autoHeight
          apiRef={apiRef}
          rows={filteredRows}
          columns={tableData.columns}
          isRowSelectable={() => false}
          onCellClick={handleCellClick}
          initialState={{
            pinnedColumns: pinnedColumns,
          }}
        />
      </GridWrapper>
  );
};

export default GradeDataTable;
